import { Map } from 'immutable';
import actions from 'redux/constants/admin/personal';

const defaultState = () => new Map({
  personalItem: new Map(),
  personalIsSubmitting: false,
  personalCreateFailed: false
})

export default (state = defaultState(), action) => {
  switch(action.type) {
    case actions.SET_PERSONAL_ITEM:
      return state.set('personalItem', action.data);
    case actions.SET_PERSONAL_ITEM_VALUE:
      return state.setIn(['personalItem', action.key], action.data);
    case actions.PERSONAL_IS_SUBMITTING:
      return state.set('personalIsSubmitting', action.data);
    case actions.PERSONAL_IS_LOADING:
      return state.set('personalIsLoading', action.data);
    case actions.SET_ADMIN_PERSONAL:
      return state.set('personalList', action.data);
    case actions.PERSONAL_CREATE_FAILED:
      return state.set('personalCreateFailed', action.data);
        default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/admin/personal.js